import { TrackEventName } from '@wix/wixstores-client-core';
var AnalyticsService = /** @class */ (function () {
    function AnalyticsService(_a) {
        var siteStore = _a.siteStore;
        this.siteStore = siteStore;
    }
    AnalyticsService.prototype.trackRemoveLineItem = function (_a) {
        var _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var lineItemId = _a.lineItemId, updatedCart = _a.updatedCart, previousCart = _a.previousCart;
        var lineItem = previousCart.lineItems.find(function (_a) {
            var _id = _a._id;
            return _id === lineItemId;
        });
        this.siteStore.trackEvent(TrackEventName.REMOVE_FROM_CART, {
            id: (_c = (_b = lineItem.source) === null || _b === void 0 ? void 0 : _b.catalogReference) === null || _c === void 0 ? void 0 : _c.catalogItemId,
            name: (_d = lineItem.name) === null || _d === void 0 ? void 0 : _d.original,
            price: (_f = (_e = lineItem.pricing) === null || _e === void 0 ? void 0 : _e.unitPrice) === null || _f === void 0 ? void 0 : _f.amount,
            quantity: (_g = lineItem.quantityInfo) === null || _g === void 0 ? void 0 : _g.confirmedQuantity,
            sku: (_j = (_h = lineItem.attributes) === null || _h === void 0 ? void 0 : _h.physicalProperties) === null || _j === void 0 ? void 0 : _j.sku,
            currency: (_k = updatedCart.businessInfo) === null || _k === void 0 ? void 0 : _k.currencyCode,
        });
    };
    AnalyticsService.prototype.trackRemoveLineItemV1 = function (_a) {
        var _b, _c, _d, _e;
        var lineItemId = _a.lineItemId, updatedCart = _a.updatedCart, previousCart = _a.previousCart;
        var lineItem = previousCart.lineItems.find(function (_a) {
            var _id = _a._id;
            return _id === lineItemId;
        });
        this.siteStore.trackEvent(TrackEventName.REMOVE_FROM_CART, {
            id: (_b = lineItem.catalogReference) === null || _b === void 0 ? void 0 : _b.catalogItemId,
            name: (_c = lineItem.productName) === null || _c === void 0 ? void 0 : _c.original,
            price: (_d = lineItem.price) === null || _d === void 0 ? void 0 : _d.amount,
            quantity: lineItem.quantity,
            sku: (_e = lineItem.physicalProperties) === null || _e === void 0 ? void 0 : _e.sku,
            currency: updatedCart.currency,
        });
    };
    return AnalyticsService;
}());
export { AnalyticsService };
//# sourceMappingURL=AnalyticsService.js.map